module.exports = ".mt-20{margin-top:20px}\n"